/**
 * May the signed-in user do an action? The screens' half of vc_be
 * utils/accessPolicy.js: the same action names, the same permission keys
 * (src/data/capabilities.json — vc_be's accessPolicy test compares them).
 *
 *   {can("fees.collect") && <AppButton …>Collect fee</AppButton>}
 *
 * The server decides; this only keeps a screen from offering what the server
 * would refuse. A super admin, a "Super Admin" staff member and the platform
 * can do everything (utils/permissions); instructors and students are not
 * admins and get false — gate their screens by their own role.
 */
import CAPABILITIES from "../data/capabilities.json";
import { permissionCategories, distributorPermissionCategory } from "../data/permissionCategories";
import { hasAnyPermission } from "./permissions";

/** The permission keys that allow an action. */
export const keysFor = (name) => CAPABILITIES[name] || [];

export function can(name) {
  const keys = CAPABILITIES[name];
  if (!keys) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn(`[access] unknown action "${name}" — add it to src/data/capabilities.json`);
    }
    return false;
  }
  return hasAnyPermission(...keys);
}

const LABELS = Object.fromEntries(
  [...permissionCategories, distributorPermissionCategory].flatMap((c) => c.permissions.map((p) => [p.key, p.label])),
);

/** "Collect Payments" for 'collect_payments' — what a refusal names. */
export const permissionLabel = (key) => LABELS[key] || key;
